// The only auth-bearing header this app sends (see api/Api.ts, api/HttpClient.ts).
// Denied from Sentry's `dataCollection.httpHeaders` so bearer tokens never leave the browser.
// The app sends no secret query params, so query filtering is left to Sentry's built-in scrubbing.
export const SENSITIVE_HEADERS = ['authorization'];

export const IGNORED_SENTRY_ERRORS = [
  'Non-Error promise rejection captured',
  /Object captured as promise rejection with keys/,
  /undefined is not an object \(evaluating '(n\.length|e\.img|i\.state|this\.currentStepObj\.(camera|configs)|o\.path\.length)'\)/,
  /initAutocomplete is not a function/,
  /Failed to fetch/,
  /AbortError: The operation was aborted/,
  /Error: no available backend found\. ERR:/,
  /Invalid call to runtime\.sendMessage\(\)\. Tab not found\./,
  /Could not load "(places_impl|places|util)"/,
  /null is not an object \(evaluating 'document\.elementFromPoint\([^)]+\)\.click'\)/,
  /Cannot read properties of null \(reading '(parentElement|classList|getBoundingClientRect)'\)/,
  /Cannot read properties of undefined \(reading '(type|camera|fireEvent|audioVolumeChange|setScreenSize|fireChangeEvent|setDefaultPosition|setCurrentPosition|fireReadyEvent|setMaxSize|img|heightCoefficient)'\)/,
  /Cannot read property '(fireEvent|fireReadyEvent|setCurrentPosition|setDefaultPosition|fireChangeEvent|setMaxSize|setScreenSize|audioVolumeChange|setIsViewable)' of undefined/,
  /Can't find variable: (Chartboost|HTMLDialogElement|gmo)/,
  /this.shouldEnforce is not a function/,
  /Failed to load https:\/\/cdn\.truv\.com\/bridge\.js/,
  /Load failed/,
];
